export enum EnvKey {
  REACT_APP_ENV = "REACT_APP_ENV",
  REACT_APP_NETWORK = "REACT_APP_NETWORK",
  REACT_APP_HASURA_URL = "REACT_APP_HASURA_URL",
  REACT_APP_CORS_PROXY_URL = "REACT_APP_CORS_PROXY_URL",
  REACT_APP_MIXPANEL_TOKEN = "REACT_APP_MIXPANEL_TOKEN",
  REACT_APP_MIXPANEL_DEBUG_ENABLED = "REACT_APP_MIXPANEL_DEBUG_ENABLED",
  REACT_APP_LAUNCH_DARKLY_SDK_DEV = "REACT_APP_LAUNCH_DARKLY_SDK_DEV",
  REACT_APP_LAUNCH_DARKLY_SDK_PROD = "REACT_APP_LAUNCH_DARKLY_SDK_PROD",
  REACT_APP_BASEDAO_DOCKERISED_URL = "REACT_APP_BASEDAO_DOCKERISED_URL",
  REACT_APP_URL = "REACT_APP_URL",
  REACT_APP_V2_URL = "REACT_APP_V2_URL",
  REACT_APP_LITE_API_URL = "REACT_APP_LITE_API_URL",
  REACT_APP_API_URL = "REACT_APP_API_URL",
  REACT_APP_BASE_URL = "REACT_APP_BASE_URL",
  REACT_APP_DAO_DEPLOYER_API = "REACT_APP_DAO_DEPLOYER_API",
  REACT_APP_RPC_NETWORK_SHADOWNET = "REACT_APP_RPC_NETWORK_SHADOWNET",
  REACT_APP_RPC_NETWORK_MAINNET = "REACT_APP_RPC_NETWORK_MAINNET",
  REACT_APP_PROPOSAL_WEBHOOK_URL = "REACT_APP_PROPOSAL_WEBHOOK_URL",
  REACT_APP_ENABLED_FEATURES = "REACT_APP_ENABLED_FEATURES",

  // Firestore emulator (optional for local dev)
  REACT_APP_FIRESTORE_EMULATOR_ENABLED = "REACT_APP_FIRESTORE_EMULATOR_ENABLED",
  REACT_APP_FIRESTORE_EMULATOR_HOST = "REACT_APP_FIRESTORE_EMULATOR_HOST",
  REACT_APP_FIRESTORE_EMULATOR_PORT = "REACT_APP_FIRESTORE_EMULATOR_PORT"
}

export enum FeatureFlag {
  lambdaDao = "lambdaDao"
}

export const HUMANITEZ_DAO = "KT1PY9PXm8NMAgSEZg7bUtFjmV2Sj64bKuVV"
